// whitelabel context

import axios from 'axios';
import { Favicon } from 'views/auth/Favicon';
import defaultLogo from '../assets/logo-small.png';
import { createContext, useState, useEffect } from 'react';
import defaultFavicon from '../assets/salesblink-icon-only-logo.png';
import { decodeJWT } from 'utils/jwtDecode';
import { setWhitelabelProps } from '../analytics/posthog';

export const WhitelabelContext = createContext();

export function WhitelabelProvider({ children }) {
    const [isWhiteLabelled, setIsWhiteLabelled] = useState(false);
    const [whitelabelDetails, setWhitelabelDetails] = useState(null);
    const [customFaviconPresent, setCustomFaviconPresent] = useState(false);

    const fetchWhitelabelData = async () => {
        try {
            const user = JSON.parse(localStorage.getItem('user'));
            const localStorageItem = decodeJWT(user?.token)
            const accountID = localStorageItem?.account_id;
            const response = await axios.get('/api/whitelabel', { params: {accountID} });
            const data = response.data.data;
            if (Object.keys(data).length > 0) setIsWhiteLabelled(true);
            else setIsWhiteLabelled(false);
            // PostHog: tag events/persons with whitelabel state (tracked, not excluded)
            setWhitelabelProps({
                whitelabelled: Object.keys(data).length > 0,
                whitelabel_domain: data?.customDomain || '',
            });
            setWhitelabelDetails({
                agencyName: data?.agencyName || 'SalesBlink',
                headerLogo: data?.headerLogo || defaultLogo,
                favicon: data?.favicon || defaultFavicon,
                whitelabelCalendar: data?.whitelabelCalendar || false,
                hideRewardsAndUpdates: data?.hideRewardsAndUpdates || false,
                customDomain: data?.customDomain || '',
                isVerified: data?.isVerified || false,
                meetViewRoles: Array.isArray(data?.meetViewRoles)
                    ? data.meetViewRoles
                    : ['admin', 'user', 'developer', 'client'],
                emailAddress: data.hasOwnProperty('emailSender') ? data.emailSender !== null && data.emailSender !== undefined && data.emailSender.sendingEnabled ? data.emailSender._id : undefined : null,
                ...(data.emailSender ? { emailAddressObject: {
                    key: data?.emailSender?.id,
                    label: data?.emailSender?.microsoft_email || data?.emailSender?.google_email || data?.emailSender?.smtpImapEmail || '',
                    value: data?.emailSender?.id,
                    objectId: data?.emailSender?._id
                }} : {})
            });
            if (data?.headerLogo) setCustomFaviconPresent(true);
        } catch (error) {
            console.log('Could not fetch whitelabel data', error);
        }
    };

    useEffect(() => {
        fetchWhitelabelData();
    }, []);

    return (
        <WhitelabelContext.Provider value={{ whitelabelDetails, setWhitelabelDetails, fetchWhitelabelData, isWhiteLabelled }}>
            {customFaviconPresent && <Favicon url={whitelabelDetails.favicon} />}
            {children}
        </WhitelabelContext.Provider>
    );
};
